module.exports = __webpack_public_path__ + "static/media/button.348a2626.jpg";